import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const PurchaseContainer = styled.div`
    background: ${COLORS.BgMain};

    padding-left: 24px;
        
    @media (min-width: ${wideBreakpoints.mobile}) {
        padding-left: 32px;
    }
`;
